import React from 'react';
import TrafalgarLogo from './TrafalgarLogo';

const Desktop = ({ windowData, openWindow, openWindows, focusWindow }) => {
  const handleIconClick = (windowId) => {
    if (openWindows.includes(windowId)) {
      focusWindow(windowId);
    } else {
      openWindow(windowId);
    }
  };

  const desktopIcons = [
    { id: 'about', icon: <TrafalgarLogo />, label: 'About', position: { top: 20, left: 20 } },
    { id: 'oscp', icon: '📋', label: 'OSCP', position: { top: 20, left: 120 } },
    { id: 'products', icon: '🚀', label: 'Products', position: { top: 20, left: 220 } },
    { id: 'contact', icon: '📧', label: 'Contact', position: { top: 120, left: 20 } }
  ];

  return (
    <div className="desktop" id="desktop">
      {desktopIcons.map(icon => (
        <div
          key={icon.id}
          className={`desktop-icon ${openWindows.includes(icon.id) ? 'selected' : ''}`}
          style={icon.position}
          onClick={() => handleIconClick(icon.id)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handleIconClick(icon.id);
            }
          }}
          tabIndex="0"
          role="button"
          aria-label={`${icon.label} - ${windowData.find(w => w.id === icon.id)?.title || icon.label}`}
        >
          <div className="icon-image">
            {icon.icon}
          </div>
          <span>{icon.label}</span>
        </div>
      ))}
    </div>
  );
};

export default Desktop;
